module.exports = __webpack_public_path__ + "static/media/starter-stering-and-replacement-red.5adc95e8.svg";